<div class="dialog-header">
  <div class="dialog-title">
    <h1>{{ dialogTitle }}</h1>
  </div>

  <a href="javascript:;" class="dialog-close" (click)="close()"
    ><i class="fal fa-times"></i
  ></a>
</div>

<div class="dialog-content">
  {{ dialogMessage }}

  <!-- <div class="mt-2">
    <nz-form-item>
      <nz-form-label
        nzFor="pin"
        nzRequired
        [nzSpan]="24"
        style="padding-bottom: 0"
        >Unesite PIN:</nz-form-label
      >
      <nz-form-control>
        <input nz-input id="pin" [formControl]="pinControl" type="password" />
      </nz-form-control>
    </nz-form-item>
  </div> -->

  <div class="mt-4">
    <button nz-button nzType="primary" (click)="confirm()">
      {{ "confirm" | translate }}
    </button>
    <button nz-button (click)="close()" class="ml-2">
      {{ "cancel" | translate }}
    </button>
  </div>
</div>
